import SideDropDownOptions from "./SideDropDownOptions";
import NotificationBell from "./NotificationBell";
import NotificationClickHandler from "./NotificationClickHandler";
import { useContext } from "react";
import { ThemeContext } from "../assets/theme/ThemeContext";

const Header = () => {
  const { themeData } = useContext(ThemeContext);

  return (
    <div
      className="header-container"
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: themeData?.topbar_color,
      }}
    >
      {/* NOTIFY-F006 review fix (L4) — renders nothing; reads/strips a push deep link's
          `?notification=<id>` and dispatches markRead. Lives here (rendered whenever
          Header is, i.e. whenever the user is signed in) so it fires regardless of which
          route the link lands on. */}
      <NotificationClickHandler />
      <img src={themeData?.logo} className="logo-bar" alt="Company Logo" />
      <div className="timesheet">
        <div className="options header-dropdown">
          <NotificationBell />
          <SideDropDownOptions />
        </div>
      </div>
    </div>
  );
};

export default Header;
